import { type Editor, EditorContent } from "@tiptap/react";
import clsx from "clsx";

import { InmailTemplateSchema } from "features/templates/schemas";
import { stringifyTemplateContent } from "features/templates/utils";

import { getSchemaMaxLength } from "common/helpers/utils";

interface TemplateSubjectInputProps {
  editor: Editor;
  isDisabled: boolean;
  errorMessage: string | false;
}

export default function TemplateSubjectEditor({
  editor,
  isDisabled,
  errorMessage,
}: TemplateSubjectInputProps) {
  const maxLength = getSchemaMaxLength(InmailTemplateSchema.entries.subject);
  const characterCount = stringifyTemplateContent(editor.getJSON()).length;

  return (
    <div className="group lg:mb-2 px-2 pt-5 lg:pt-2">
      <label
        htmlFor="subjectEditorContent"
        className="mb-0.5 ml-1 text-button-xxs text-black-500"
      >
        Subject
      </label>

      <div
        className={clsx(
          "flex items-end gap-x-2 border-b border-b-black-200 px-1 pb-1.5 transition-colors",
          isDisabled && "text-black-500",
          errorMessage
            ? "has-[:focus]:border-red-400"
            : "has-[:focus]:border-purple-400",
        )}
      >
        <EditorContent
          id="subjectEditorContent"
          editor={editor}
          className="flex-1 min-w-0 [&_.tiptap]:outline-none w-full bg-transparent text-md lg:text-sm outline-none [&_.node-variable]:align-middle"
        />

        <span
          className={clsx(
            "text-xs transition-[color]",
            characterCount > maxLength ? "text-red-500" : "text-black-500",
          )}
        >
          {characterCount}/{maxLength}
        </span>
      </div>

      {/* Error message */}
      {errorMessage && (
        <span className="mt-1 inline-flex text-xs text-red-500">
          {errorMessage}
        </span>
      )}
    </div>
  );
}
